export const apiHost = {
  "DEV": {
    "us-west-2": 'https://l0v7hqc056.execute-api.us-west-2.amazonaws.com'
  },
  "BETA": {
    "us-west-2": 'https://i9p4cit4gb.execute-api.us-west-2.amazonaws.com'
  },
  "GAMMA": {
    "eu-west-1": 'https://ns5dsxvcz0.execute-api.eu-west-1.amazonaws.com',
    "us-east-1": 'https://bh1vge71si.execute-api.us-east-1.amazonaws.com',
    "us-west-2": 'https://ubok6bqwhd.execute-api.us-west-2.amazonaws.com'
  },
  "PROD": {
    "eu-west-1": 'https://j7ch8r2cui.execute-api.eu-west-1.amazonaws.com',
    "us-east-1": 'https://h1hpn38ap8.execute-api.us-east-1.amazonaws.com',
    "us-west-2": 'https://0y7yf1vt2c.execute-api.us-west-2.amazonaws.com'
  }
}

export const groundingGenerationApiHost = {
  "DEV": {
    "us-west-2": 'https://1u5yhlq3g9.execute-api.us-west-2.amazonaws.com'
  },
  "BETA": {
    "us-west-2": 'https://1u5yhlq3g9.execute-api.us-west-2.amazonaws.com'
  },
  "GAMMA": {
    "eu-west-1": 'https://1u5yhlq3g9.execute-api.us-west-2.amazonaws.com',
    "us-east-1": 'https://1u5yhlq3g9.execute-api.us-west-2.amazonaws.com',
    "us-west-2": 'https://1u5yhlq3g9.execute-api.us-west-2.amazonaws.com'
  },
  "PROD": {
    "eu-west-1": 'https://f70tij0t1f.execute-api.us-east-1.amazonaws.com',
    "us-east-1": 'https://f70tij0t1f.execute-api.us-east-1.amazonaws.com',
    "us-west-2": 'https://f70tij0t1f.execute-api.us-east-1.amazonaws.com'
  }
}

export const mmirUIIssueReportingApiHost = {
  "PROD": {
    "us-east-1": 'https://oya3kptop4.execute-api.us-east-1.amazonaws.com',
  }
}

export const textToAkgEntityLinkingApiHost = {
  "DEV": {
    "us-west-2": "https://3wc0pamx68.execute-api.us-west-2.amazonaws.com"
  },
  "BETA": {
    "us-west-2": 'https://3wc0pamx68.execute-api.us-west-2.amazonaws.com'
  },
  "PROD": {
    "us-east-1": 'https://n2g9l6hzrh.execute-api.us-east-1.amazonaws.com'
  }
}

export const visualQaExperimentalApiHost = {
  "DEV": {
    "us-west-2": 'https://mp02seezsf.execute-api.us-east-1.amazonaws.com'
  },
  "BETA": {
    "us-west-2": 'https://mp02seezsf.execute-api.us-east-1.amazonaws.com'
  },
  "GAMMA": {
    "eu-west-1": 'https://mp02seezsf.execute-api.us-east-1.amazonaws.com',
    "us-east-1": 'https://mp02seezsf.execute-api.us-east-1.amazonaws.com',
    "us-west-2": 'https://mp02seezsf.execute-api.us-east-1.amazonaws.com'
  },
  "PROD": {
    "eu-west-1": 'https://mp02seezsf.execute-api.us-east-1.amazonaws.com',
    "us-east-1": 'https://mp02seezsf.execute-api.us-east-1.amazonaws.com',
    "us-west-2": 'https://mp02seezsf.execute-api.us-east-1.amazonaws.com'
  }
}

const lensBetaAgentCoreUrl = 'https://bedrock-agentcore.us-east-1.amazonaws.com/runtimes/arn%3Aaws%3Abedrock-agentcore%3Aus-east-1%3A155372730338%3Aruntime%2Fmmir_answer_tool_beta-5gl4q6HA76/invocations?qualifier=DEFAULT';
const MMIR_MCP_BETA_ACCOUNT = '155372730338';
const AGENTCORE_RUNTIME_ARN = /^arn:aws:bedrock-agentcore:([a-z0-9-]+):([0-9]{12}):runtime\/[A-Za-z0-9_-]+$/;

export function agentCoreInvocationUrl(runtimeArn, expectedRegion, expectedAccount = MMIR_MCP_BETA_ACCOUNT) {
  const match = AGENTCORE_RUNTIME_ARN.exec(runtimeArn || '');
  if (!match || match[1] !== expectedRegion || match[2] !== expectedAccount) return null;
  return `https://bedrock-agentcore.${expectedRegion}.amazonaws.com/runtimes/${encodeURIComponent(runtimeArn)}/invocations?qualifier=DEFAULT`;
}

export async function resolveLensApiHost(stage, region, fetchImpl = (...args) => window.fetch(...args)) {
  const settings = await resolveLensSettings(stage, region, fetchImpl);
  return settings?.answerApiHost || null;
}

export async function resolveLensSettings(stage, region, fetchImpl = (...args) => window.fetch(...args)) {
  const fallback = lensApiHost?.[stage]?.[region] || null;
  if (stage !== 'BETA') return fallback ? { answerApiHost: fallback } : null;
  try {
    const response = await fetchImpl('/settings.json', { cache: 'no-store' });
    if (!response.ok) return null;
    const settings = await response.json();
    // BONES serializes settings.json values as strings in deployed stages.
    // Keep the beta gate fail-closed while accepting its explicit boolean form.
    if (settings?.lensEnabled !== true && settings?.lensEnabled !== 'true') return null;
    const answerApiHost = agentCoreInvocationUrl(
      settings?.lensRuntimeArn,
      settings?.lensRuntimeRegion,
    );
    return answerApiHost ? { answerApiHost } : null;
  } catch (error) {
    return null;
  }
}

// Lens calls the full Answer Tool runtime in MMIR MCP beta. That runtime owns
// web search, beta VTAG FULL grounding, trace projection and citation metadata.
export const lensApiHost = {
  "DEV": { "us-west-2": lensBetaAgentCoreUrl },
  "BETA": { "us-west-2": lensBetaAgentCoreUrl },
  "GAMMA": {},
  "PROD": {}
};

export const visualQaDataUploadApiHost = {
  "DEV": {
    "us-west-2": 'https://5bryq529z4.execute-api.us-west-2.amazonaws.com'
  },
  "BETA": {
    "us-west-2": 'https://5bryq529z4.execute-api.us-west-2.amazonaws.com'
  },
  "GAMMA": {
    "eu-west-1": 'https://5bryq529z4.execute-api.us-west-2.amazonaws.com',
    "us-east-1": 'https://5bryq529z4.execute-api.us-west-2.amazonaws.com',
    "us-west-2": 'https://5bryq529z4.execute-api.us-west-2.amazonaws.com'
  },
  "PROD": {
    "eu-west-1": 'https://5bryq529z4.execute-api.us-west-2.amazonaws.com',
    "us-east-1": 'https://5bryq529z4.execute-api.us-west-2.amazonaws.com',
    "us-west-2": 'https://5bryq529z4.execute-api.us-west-2.amazonaws.com'
  }
}
